<template>
	<PageContainer
		v-bind="$attrs"
		:spacing="spacing"
	>
		<slot />
	</PageContainer>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';

	import { IndexedObject } from '@cnamts/vue-dot/src/types';

	@Component({
		inheritAttrs: false
	})
	export default class AppPage extends Vue {
		get spacing(): string {
			const spacingMapping: IndexedObject<string> = {
				xs: 'py-4 px-2',
				sm: 'py-6 px-4',
				md: 'py-10 px-8',
				lg: 'py-10 px-8',
				xl: 'py-10 px-8'
			};

			return spacingMapping[this.$vuetify.breakpoint.name];
		}
	}
</script>
